export const MODULE_PREFIX = 'auth/user';
